import { ClientOutput } from '@ddt-web/domain';

import { TabDataTransform } from './interfaces/tab.interface';

export class TabDisplayConfig {
	public static create(options: TabDisplayConfigOptions): TabDisplayConfig {
		return new TabDisplayConfig(
			options.active,
			options.visible,
			options.transpose,
			options.conditions,
			options.hideEmptyTab,
			options.clientOutput,
			options.isIterative,
			options.hideWithOtherTabs,
			options.isDominantTab,
			options.hideIfPartner,
			options.showInPartnerOnly,
			options.showInPublicView
		);
	}
	constructor(
		public readonly active: boolean = true,
		public readonly visible: boolean = true,
		public readonly transpose: boolean = false,
		public readonly conditions: TabDataTransform[] = [],
		public readonly hideEmptyTab: boolean = false,
		public clientOutput = null,
		public readonly isIterative: boolean = false,
		// hideWithOtherTabs: if the value is true, it means we only show this tab when there is at least one other tab showing.
		public readonly hideWithOtherTabs: boolean = false,
		// isDominantTab: marks a tab as dominant, it means we take into consideration the error at this tab level if there is no error at the component data level
		// If multiple tabs are marked as dominant, the error from the first dominant tab is used
		// This is used for showing the error template when a dominant tab has error, but the component data is successful
		public readonly isDominantTab: boolean = false,
		// true if tab should be hidden when user is partner
		public readonly hideIfPartner: boolean = false,
		// if flag is true we only show the tab if user is partner, otherwise we show for every user
		public readonly showInPartnerOnly: boolean = false,
		// if flag is false, we only show the tabs which are accessible in public view, otherwise all the tabs are visible to user
		public readonly showInPublicView: boolean = false
	) { }
}

export interface TabDisplayConfigOptions {
	active?: boolean;
	visible?: boolean;
	transpose?: boolean;
	conditions?: TabDataTransform[];
	hideEmptyTab?: boolean;
	clientOutput?: ClientOutput;
	isIterative?: boolean;
	hideWithOtherTabs?: boolean;
	isDominantTab?: boolean;
	hideIfPartner?: boolean;
	showInPartnerOnly?: boolean;
	showInPublicView?: boolean;
}
